import React from 'react';

import { StatusPill } from '@lyearn/ui';
import { useBaseCard } from '@/modules/content/components/ContentCard/BaseCard/Provider';
import { BaseCardComposition } from '@/modules/content/components/ContentCard/BaseCard/types';
import { ContentCardTypeEnum } from '@/modules/content/config/cards';

const Status: BaseCardComposition['Status'] = (props) => {
  const { status, cardType, progress } = useBaseCard();

  if (!status) {
    return null;
  }

  if (cardType === ContentCardTypeEnum.Mini && progress === 100) {
    return null;
  }

  return (
    <StatusPill
      appearance={status.appearance}
      className="z-10"
      label={status.label}
      variant="light"
      {...props}
    />
  );
};

export default Status;
